import { render, staticRenderFns } from "./news-no-result.vue?vue&type=template&id=92f266ca&lang=pug&"
import script from "./news-no-result.vue?vue&type=script&lang=js&"
export * from "./news-no-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports